import { createContext } from 'react';
import { Point } from './ivrTypes';

type IvrTreeContextProps = {
  hideTree: boolean;
  ivrFrameSize?: { width: number; height: number; leftTopPoint: Point; rightBottomPoint: Point };
  nodeClick?: Function;
  selectedNodeId?: string;
  toNode?: any;
};

const IvrTreeContext = createContext<IvrTreeContextProps>({ hideTree: false });

export default IvrTreeContext;
